<template>
  <el-dialog
    title="关闭服务请求"
    :visible.sync="visible"
    width="400px"
    @close="$emit('update:show', false)"
  >
    <el-form
      ref="form"
      label-position="top"
      label-width="90px"
      :model="model"
      :rules="formRules"
    >
      <el-form-item label="关闭原因" prop="desc">
        <el-input
          size="small"
          type="textarea"
          :rows="3"
          v-model="model.desc"
          placeholder="请输入关闭服务请求的原因"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { serviceQuestClose } from '../service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        desc: [
          { required: true, message: '请输入关闭原因', trigger: 'change' },
        ],
      },
      submiting: false,
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res = await serviceQuestClose(this.model)
          if (res.code == 0) {
            this.$emit('updated', res.data)
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>